import React from "react";

const AccountLockedSummary = ({ isAccountLocked, isPmaUser }) => {
  return (
    <div className="upsell-validation mx-auto">
      <div
        className="alert alert-danger"
        role="alert"
      >
        <div>
          <strong class="text-black">Your account has been locked.</strong>
        </div>
        <br />
        <div>
          <strong className="text-black">
            Please contact our{" "}
            {`${isPmaUser ? "Portfolio Services" : "Customer Service"}`} Team:
          </strong>
        </div>
        <ul>
          <li className="text-left">
            Call <strong>1300 880 160</strong>
          </li>
          <li className="text-left">
            Email{" "}
            <a
              href={`mailto:${
                isPmaUser
                  ? "invest@investsmart.com.au"
                  : "support@investsmart.com.au"
              }`}
              className="text-underline text-danger"
            >
              {`${
                isPmaUser
                  ? "invest@investsmart.com.au"
                  : "support@investsmart.com.au"
              }`}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AccountLockedSummary;
